module.exports = __webpack_public_path__ + "static/media/arrowColor.ef07f8a4.svg";